export const SET_CONTENTUL_PROGRAMS = "SET_CONTENTUL_PROGRAMS";
export const SET_CONTENTUL_STAFF = "SET_CONTENTUL_STAFF";
export const SET_CONTENTFUL_EVENTS = "SET_CONTENTFUL_EVENTS";
export const SET_CONTENTFUL_CAREERS = "SET_CONTENTFUL_CAREERS";
export const SET_CONTENTFUL_JOB = "SET_CONTENTFUL_JOB";
export const SET_MEET_CARDS = "SET_MEET_CARDS";
export const SET_CONTENTFUL_GYMNASTIC_MEETS = "SET_CONTENTFUL_GYMNASTIC_MEETS";
export const SET_CONTENTFUL_CALENDAR = "SET_CONTENTFUL_CALENDAR";
export const SET_CONTENTFUL_SITE_ANNOUNCEMENT = "SET_CONTENTFUL_SITE_ANNOUNCEMENT";

export function setContentfulPrograms(response) {
  return {
    type: SET_CONTENTUL_PROGRAMS,
    payload: response,
  };
}

export function setContentfulStaff(response) {
  return {
    type: SET_CONTENTUL_STAFF,
    payload: response,
  };
}

export function setContentfulEvents(response) {
  return {
    type: SET_CONTENTFUL_EVENTS,
    payload: response,
  };
}

export function setContentfulCareers(response) {
  return {
    type: SET_CONTENTFUL_CAREERS,
    payload: response,
  };
}

export function setContentfulJob(response) {
  return {
    type: SET_CONTENTFUL_JOB,
    payload: response,
  };
}

export function setContentfulMeetCards(response) {
  return {
    type: SET_MEET_CARDS,
    payload: response,
  };
}

export function setContentfulGymnasticMeets(response) {
  return {
    type: SET_CONTENTFUL_GYMNASTIC_MEETS,
    payload: response,
  };
}

export function setContentfulCalendar(response) {
  return {
    type: SET_CONTENTFUL_CALENDAR,
    payload: response,
  };
}

export function setContentfulSiteAnnouncement(response) {
  return {
    type: SET_CONTENTFUL_SITE_ANNOUNCEMENT,
    payload: response,
  };
}
